module.exports = __webpack_public_path__ + "static/img/index_image01.c5f334cc.png";